import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsAmazonSeller() {
  return (
    <IntegrationDocTemplate
      title="Amazon Seller Central (SP-API)"
      category="Marketplace"
      status="live"
      summary="Full Amazon Selling Partner API integration — orders, listings, catalog, pricing, advertising, FBA, MCF, reports, feeds, finances, and returns. Login with Amazon (LWA) OAuth + AWS Signature v4. Per-operation token bucket rate limiting."
      prerequisites={[
        'Active Amazon Seller account (US or international marketplace).',
        'SP-API Developer account ($1,400/yr) — register at developer-docs.amazon.com.',
        'LWA application with refresh token (created during OAuth consent).',
        'AWS IAM role for SigV4 signing (separate from your seller AWS account).',
      ]}
      connectSteps={[
        <>Text us your phone number on the landing page → tell us "Amazon seller". Our <code>amazon_listing_agent</code> initiates SP-API OAuth.</>,
        <>Authorize Commerce Index in your Seller Central account — Apps & Services → Develop Apps → Manage → Authorize new developer.</>,
        <>Paste the SP-API redirect URI we provide; complete OAuth consent. Refresh token is captured automatically.</>,
        <>First sync completes within 15 minutes: ~30 days of orders, all listings, FBA inventory.</>,
      ]}
      syncedData={[
        { type: 'Orders', detail: 'GetOrders with status filtering; line items, shipment status, returns' },
        { type: 'Listings', detail: 'Listings Items 2021-08-01; create, update, delete; attributes per product type' },
        { type: 'Inventory', detail: 'FBA + seller-fulfilled summaries; per-marketplace granularity' },
        { type: 'Pricing', detail: 'Item + competitive pricing; offer count + buy box status' },
        { type: 'Advertising', detail: 'Sponsored Products campaigns, ad groups, keywords (separate Advertising API)' },
        { type: 'Reports', detail: 'Orders, inventory ledger, FBA returns, settlements' },
        { type: 'Feeds', detail: 'Bulk product/inventory updates; chunked uploads with completion polling' },
        { type: 'Finances', detail: 'ListFinancialEvents — settlements, refunds, fees, reserves' },
      ]}
      agents={[
        { id: 'amazon_listing_agent', name: 'amazon_listing_agent', role: 'Listing creation + A+ content + brand registry' },
        { id: 'amazon_advertising_agent', name: 'amazon_advertising_agent', role: 'Sponsored Products/Brands optimization' },
        { id: 'amazon_repricing_agent', name: 'amazon_repricing_agent', role: 'Dynamic pricing within guardrails' },
        { id: 'head_ecommerce', name: 'head_ecommerce', role: 'Channel routing director' },
      ]}
      troubleshooting={[
        { question: 'SP-API returns 403 on first call', answer: 'LWA refresh token expired or AWS IAM role missing. Re-authorize in Seller Central; verify AWS IAM "ExecuteAPI" permission is granted.' },
        { question: 'Rate limit (429) errors', answer: 'Each SP-API operation has its own token bucket. Our client uses adaptive backoff — most 429s self-resolve within 60s. Check /api/v2/platforms/sync_log for retry counts.' },
        { question: 'Listings fail with "missing required attribute"', answer: 'Amazon changes product-type required attributes frequently. Check your sync_log for the specific attribute name and update via our listing UI or via PUT /listings/...' },
        { question: 'FBA inventory shows 0 when I have stock', answer: 'FBA inventory reports lag by ~1 hour. If still 0 after 2 hours, run a manual sync from /dashboard/inventory.' },
      ]}
      supportLink="/contact"
    />
  );
}
